export enum TdrRegelAard {
  VERTREK = 'VERTREK',
  AANKOMST = 'AANKOMST'
}
